import classNames from 'classnames';
import { Typography } from '../typography/typography';
import styles from './checkbox.module.scss';
import Icon from '../icons/icon';

interface CheckboxProps {
  name?: string;
  type?: 'white' | 'yellow' | 'ecommercePrimary';
  className?: string;
  label?: React.ReactNode;
  isChecked?: boolean;
  onChange?: (isChecked: boolean) => void;
  icon?: React.ReactNode;
  isDisabled?: boolean;
  dataCy?: string;
}
export const Checkbox = ({
  name,
  label,
  isChecked = false,
  onChange,
  icon,
  type = 'yellow',
  isDisabled = false,
  dataCy = 'checkbox',
}: React.PropsWithChildren<CheckboxProps>) => {
  const iconColor = () => {
    if (isDisabled) {
      return 'var(--grey-200)';
    }

    switch (type) {
      case 'ecommercePrimary':
        return 'white';
      case 'yellow':
      case 'white':
      default:
        return 'var(--grey-700)';
    }
  };
  return (
    <div
      className={classNames('flex justify-start items-center', {
        'cursor-pointer': !isDisabled,
        'cursor-not-allowed': isDisabled,
        [styles.checkbox]: type === 'yellow',
        [styles.checkbox2]: type === 'white',
        [styles.ecommerceCheckboxPrimary]: type === 'ecommercePrimary',
      })}
      data-cy={dataCy}
      onClick={() => !isDisabled && onChange && onChange(!isChecked)}
    >
      <input type="checkbox" name={name} checked={isChecked} onChange={() => {}} disabled={isDisabled} />
      <span className="shrink-0">
        {icon ? icon : <Icon icon="Check" className="w-[14px]" stroke={iconColor()} strokeWidth={4} />}
      </span>
      {label && <Typography type="text-sm">{label}</Typography>}
    </div>
  );
};
